import React from 'react';
import LogInForm from './LoginForm';

const LogIn = () => (
    <>
        <LogInForm />
    </>
);

export default LogIn;
